module.exports = __webpack_public_path__ + "img/adress.5234bee0.svg";